import { useEffect } from "react";
import { useMarkersContext } from "../context";
import { useCarMovingMarkerLayout } from "features/navigation/NavigationHistorySlider/hooks/useCarMovingMarkerLayout";

export const useTravelDirectionMarker = (
  carHistoryTravelPointIndex?: number
) => {
  const { updateLayers } = useMarkersContext();
  const carMovingMarkerLayout = useCarMovingMarkerLayout(
    carHistoryTravelPointIndex
  );

  useEffect(() => {
    updateLayers([carMovingMarkerLayout]);
  }, [carMovingMarkerLayout, updateLayers]);
};
